import { ChatMap, } from "@shared";
import { writable } from "../../utils/stores";
import { notEq } from "../utils";
export class ChatSummaryUpdates {
    notificationsMuted;
    atEveryoneMuted;
    archived;
    rulesAccepted;
    latestMessage;
    frozen;
    name;
    description;
    permissions;
    gateConfig;
    eventsTTL;
    isPublic;
    isEmpty() {
        return Object.values(this).every((v) => v === undefined);
    }
}
export const chatSummaryLocalUpdates = writable(new ChatMap(), undefined, notEq);
